// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 45 54", width: "45", height: "54" }, props),
        React.createElement("path", { d: "M22.5,9.8c5.9,0,11.2,2.2,15.2,5.9l3.5-3.1c0.9-0.8,2.3-0.7,3.2,0.2c0.8,0.9,0.7,2.3-0.2,3.1L40.7,19 c2.7,3.6,4.3,8.1,4.3,12.9C45,44.1,34.9,54,22.5,54C10.1,54,0,44.1,0,31.9S10.1,9.8,22.5,9.8z M24.2,16.8v14.7L11.4,42.6 c2.9,2.9,6.8,4.6,11.1,4.6c8.7,0,15.8-7.1,15.8-15.8S29.8,16.8,24.2,16.8z M31.5,0c1.2,0,2.2,1.2,2.2,2.5c0,1.2-1,2.5-2.2,2.5h-18 c-1.2,0-2.2-1.2-2.2-2.5c0-1.2,1-2.5,2.2-2.5H31.5z", className: "Stopwatch45x54__st0" })));
};
Icon.displayName = 'Stopwatch45x54';
export default Icon;
//# sourceMappingURL=Stopwatch45x54.js.map